export default "__VITE_ASSET__8a1f4c37__"